var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.LoggedIn === true
    ? _c(
        "div",
        { staticClass: "toolbar bottomToolbarContainer", style: _vm.cssVars },
        [
          _c("bottom-items", {
            attrs: {
              serviceId: _vm.serviceId,
              bottomItemsData: _vm.bottomItemsData,
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }